import React from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { SuccessfullyUpdatedTemplate } from '@/components/templates/SuccessfullyUpdatedTemplate/index'
import { SuccessfullyUpdatedTemplateProps } from '@/components/templates/SuccessfullyUpdatedTemplate/types'

export interface SuccessfulProfileUpdateParams
  extends Omit<SuccessfullyUpdatedTemplateProps, 'onNavigation'> {}

export const SuccessfulProfileUpdateScreen: React.FC = () => {
  const navigate = useNavigate()
  const location = useLocation()

  // Get params from location state
  const params = location.state as SuccessfulProfileUpdateParams | undefined

  if (!params) {
    // Fallback if no params provided - redirect to profile settings
    navigate('/profile/profile-settings', { replace: true })
    return null
  }

  const handleNavigation = () => {
    if (!params.doneRoute) {
      navigate('/profile/profile-settings', { replace: true })
      return
    }

    if (params.navigationMethod === 'dismiss') {
      // In web app, we can't really "dismiss", so we navigate back
      navigate(params.doneRoute, { replace: true })
      return
    }

    navigate(params.doneRoute, { replace: true })
  }

  return (
    <SuccessfullyUpdatedTemplate {...params} onNavigation={handleNavigation} />
  )
}

export default SuccessfulProfileUpdateScreen
